const isSticky = (sticky) => (sticky && (sticky.side === 'right' || sticky.side === 'left'));
export default isSticky;
